import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowUpRight, Menu, X } from 'lucide-react';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
import { navItems } from '../data/navigation';
import { DEMO_URL, LOGIN_URL } from '../data/links';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/mb2jg2c71vCieLgRY47vhh/logo_bleu.png';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <header className="sticky top-0 z-50 px-4 pt-4 sm:px-6" data-id="element-21" data-mp="2wjfis4zmayhm">
      <div className="mx-auto max-w-[1080px] rounded-2xl border border-white/70 bg-white/85 px-4 py-2.5 shadow-[0_8px_30px_rgba(8,8,82,0.06)] backdrop-blur-md sm:px-5" data-id="element-22" data-mp="31bp4t9xm3eem">
        <div className="flex items-center justify-between gap-4" data-id="element-23" data-mp="3baelx0hooutt">
          <a href="#" aria-label={t.nav.home} className="shrink-0" data-id="element-24" data-mp="3bbzdqicm5znz">
            <img src={LOGO_URL} alt="Rewayz" className="h-6 w-auto" style={{
            height: '24px'
          }} data-id="element-25" data-mp="3fcrnrdtb88lb" />
          </a>

          <nav aria-label={t.nav.main} className="hidden lg:block" data-id="element-26" data-mp="2wmfjaq8pxe7b">
            <ul className="flex items-center gap-1" data-id="element-27" data-mp="2rli2oi3cws7x">
              {navItems.map(item => <li key={item.key} data-id="element-28" data-mp="2mm54x2ay60qk">
                  {item.disabled ? <span aria-disabled="true" className="flex cursor-not-allowed items-center gap-1 rounded-lg px-3 py-2 text-[15px] text-[rgba(8,8,82,0.35)]" data-id="element-29" data-mp="2hnlil0sfymxo">
                      {t.nav[item.key]}
                    </span> : <a href={item.href} className="flex items-center gap-1 rounded-lg px-3 py-2 text-[15px] text-blue-reways-950-lock transition-colors hover:bg-blue-reways-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-reways-500" data-id="element-30" data-mp="35l0x6838w51r">
                      {t.nav[item.key]}
                    </a>}
                </li>)}
            </ul>
          </nav>

          <div className="hidden items-center gap-2.5 lg:flex" data-id="element-31" data-mp="1rfxi6k9mba7t">
            <LanguageSwitcher data-id="element-32" data-mp="1wbcw1c7ml648" />
            <a href={LOGIN_URL} target="_blank" rel="noopener noreferrer" className="rounded-xl bg-grey-100 px-4 py-2.5 text-[15px] font-medium text-blue-reways-950-lock transition-colors hover:bg-grey-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-reways-500" data-id="element-33" data-mp="1weh5anzy6s1r">
              {t.cta.login}
            </a>
            <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-xl bg-blue-reways-950-lock px-4 py-2.5 text-[15px] font-medium text-white transition-opacity hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-reways-500" data-id="element-34" data-mp="1cmklxlgfmbqp">
              {t.cta.demo}
              <ArrowUpRight className="h-4 w-4 text-orange-rewayz-500" aria-hidden="true" data-id="element-35" data-mp="2xznlu2gehhf2" />
            </a>
          </div>

          <button type="button" onClick={() => setIsOpen(v => !v)} aria-expanded={isOpen} aria-controls="mobile-menu" aria-label={isOpen ? t.nav.closeMenu : t.nav.openMenu} className="rounded-lg p-2 text-blue-reways-950-lock transition-colors hover:bg-blue-reways-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-reways-500 lg:hidden" data-id="element-36" data-mp="hg3gm0we0gca">
            {isOpen ? <X className="h-6 w-6" data-id="element-37" data-mp="105t9giglas1k" /> : <Menu className="h-6 w-6" data-id="element-38" data-mp="108fjcoqydjmy" />}
          </button>
        </div>

        <AnimatePresence initial={false} data-id="element-39" data-mp="1f2kbkzhnehuv">
          {isOpen && <motion.div id="mobile-menu" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.22, 1, 0.36, 1]
        }} className="overflow-hidden lg:hidden" data-id="element-40" data-mp="1a5ad6uca6vuw">
              <nav aria-label={t.nav.mobile} className="pt-3" data-id="element-41" data-mp="230rssdypgcjb">
                <ul className="flex flex-col" data-id="element-42" data-mp="27wgqscv2tldi">
                  {navItems.map(item => <li key={item.key} data-id="element-43" data-mp="2cxwbg3tcdpvd">
                      {item.disabled ? <span aria-disabled="true" className="flex cursor-not-allowed items-center justify-between border-t border-grey-100 py-3 text-[15px] text-[rgba(8,8,82,0.35)]" data-id="element-44" data-mp="2gyq3n9dthqu2">
                          {t.nav[item.key]}
                        </span> : <a href={item.href} onClick={() => setIsOpen(false)} className="flex items-center justify-between border-t border-grey-100 py-3 text-[15px] text-blue-reways-950-lock" data-id="element-45" data-mp="1t716nfq1we6s">
                          {t.nav[item.key]}
                        </a>}
                    </li>)}
                </ul>
                <div className="mt-4 flex flex-col gap-2.5 pb-1" data-id="element-46" data-mp="t1yyrp3a7n0r">
                  <LanguageSwitcher variant="segmented" data-id="element-47" data-mp="oykiqyfcf6nb" />
                  <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-xl bg-blue-reways-950-lock px-4 py-3 text-[15px] font-medium text-white" data-id="element-48" data-mp="p16pwwybnk50">
                    {t.cta.demo}
                    <ArrowUpRight className="h-4 w-4 text-orange-rewayz-500" aria-hidden="true" data-id="element-49" data-mp="5abh7xrwtob5" />
                  </a>
                  <a href={LOGIN_URL} target="_blank" rel="noopener noreferrer" className="rounded-xl bg-grey-100 px-4 py-3 text-center text-[15px] font-medium text-blue-reways-950-lock" data-id="element-50" data-mp="1asucwgj335o">
                    {t.cta.login}
                  </a>
                </div>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}